export default "__VITE_ASSET__CZiN3sNb__"